import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Label,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";

import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { MapAllObjectUnits, MapTotalForArrangement, MapUnitForArrangement } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import ReactSelect from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";


const ItemLocDriverArrangementReport = (props) => {
  const [confirmClose, setConfirmClose] = useState(false);

  const columns = [
    { dataField: "item", hidden: true },
    { dataField: "item", text: "Product Name" },
    { dataField: "category", text: "Category" },
    { dataField: "sub_category", text: "Sub Category" },
    {
      dataField: "value",
      text: "Quantity",
      formatter: (cell, row, rowIndex) => {
        return row.value + " " + row.unit
      },
    },
    // {
    //   text: "Quantity",
    //   formatter: (cell, row) => {
    //     return ExportAvailableInCSVForReports(row.quantity)
    //   },
    // },
  ];

  useEffect(() => {
    loadAllTimeStamps();
    loadAllVehicles();
  }, []);
  const [allTimeStamps, setAllTimeStamps] = useState([]);
  const [selectedTimestamp, setSelectedTimestamp] = useState();
  const [selectedVehicle, setSelectedVehicle] = useState()
  const loadAllTimeStamps = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "itemorders/get_arrangement_marks";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllTimeStamps(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    loadItems();
  }, [selectedTimestamp, selectedVehicle]);
  const [data1, setData1] = useState([]);
  const [arrData, setArrData] = useState([]);

  const loadItems = async () => {
    preloader(true);
    let data_to_send = {
      mark_time:
        selectedTimestamp && selectedTimestamp !== ""
          ? selectedTimestamp
          : null,
      vehicle_id: selectedVehicle?._id
    };

    let url =
      process.env.REACT_APP_BASEURL + "itemorders/location_vehicle_arrangement_report";
    const response = await postSubmitForm(url, data_to_send);

    if (response && response.status === 1 && response.data) {
      setArrData(response.data);
      preloader(false)
    } else {
      showNotification(response.message, "Error");
    }
    preloader(false);
  };

  const [allVehicles, setAllVehicles] = useState([]);
  const loadAllVehicles = async () => {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "vehicles/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const transformedData = response.data.map(item => {
        return {
          ...item,
          label: item.name,
          value: item._id,
        };
      });
      preloader(false)
      setAllVehicles(transformedData);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
  };

  const getColumns = (values) => {
    const columns = [
      { dataField: "_id", hidden: true },
      {
        dataField: "_id",
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
        text: props.t("#"),
        headerStyle: (colum, colIndex) => {
          return { width: "50px" };
        },
      },
    ];

    for (let key in values[0]) {
      if (key === "Total") {
        columns.push({
          text: key,
          dataField: key,
          formatter: (cell, row, rowIndex) => {
            return (MapTotalForArrangement(cell));
          },
        });
      } else {
        if (key !== "Item Name") {
          columns.push({
            text: key,
            dataField: key,
            formatter: (cell, row, rowIndex) => {
              return (MapAllObjectUnits(cell));
            },
          });
        }
        if (key === "Item Name") {
          columns.push({
            text: key,
            dataField: key,
          });
        }
        // else {
        //   columns.push({
        //     text: key,
        //     dataField: key,
        //   });
        // }
      }
    }

    return columns;
  };

  const printReport = async () => {
    if (!selectedTimestamp) {
      let url =
        process.env.REACT_APP_BASEURL + "itemorders/mark_arrangement_report";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        loadAllTimeStamps();
        printPage();
      } else {
        showNotification(response.message, "Error");
      }
    } else {
      printPage()
    }
  };
  const handleDownload = async (divName) => {
    const fileName = "item_arrangement_report";
    const exportType = "xls";
    let alldata = [divName];
    let d3;
    let d = alldata.map((i) => {
      // console.log(i);
      return i.items;
    });

    let d1 = d.map((i) => {
      // console.log(i, "cfgfcg");
      return (d3 = i);
    });

    if (d3) {
      var data = [];
      JSON.parse(JSON.stringify(d3)).forEach(function (v) {
        // console.log(v);
        data.push({
          product: v.item,
          Category: v.category,
          SubCategory: v.sub_category,
          Quantity: v.value,
          Unit: v.unit,
          // Quantity: MapAllObjectUnits(v.quantity),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleDownload2 = (data) => {
    const exportData = [];
    // Process each location
    data.forEach((locationData) => {
      const locationName = locationData.location || " ";

      // Dynamically extract all branch keys from items
      const branchKeys = new Set();
      locationData.items.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== "Item Name" && key !== "Total") {
            branchKeys.add(key);
          }
        });
      });
      const branchArray = Array.from(branchKeys);

      // Add location header row with branches
      const headerRow = { "Item Name": `<strong> ${locationName} </strong>`};
      branchArray.forEach((branch) => {
        headerRow[branch] = '';
      });
      headerRow["Total"] = "";
      headerRow["Unit"] = "";
      exportData.push(headerRow);

      // Process each item
      locationData.items.forEach((item) => {
        const itemRow = { "Item Name": item["Item Name"] };
        // Fill branch data
        branchArray.forEach((branch) => {
          if (item[branch] && Object.keys(item[branch]).length > 0) {
            const branchUnits = Object.entries(item[branch])
              .map(([unit, quantity]) => `${quantity}`)
              .join(", ");
            itemRow[branch] = branchUnits;
          } else {
            itemRow[branch] = "";
          }
        });

        // Handle Total column
        if (item.Total && Object.keys(item.Total).length > 0) {
          const totalUnits = Object.entries(item.Total)
            .map(([unit, quantity]) => `${quantity}`)
            .join(", ");
          itemRow["Total"] = totalUnits;

          // Add Unit column
          itemRow["Unit"] = Object.keys(item.Total).join(", ");
        } else {
          itemRow["Total"] = "";
          itemRow["Unit"] = "";
        }

        exportData.push(itemRow);
      });

      // Add an empty row for spacing
      exportData.push({});
    });
    const fileName = selectedVehicle ? selectedVehicle?.label : "TOTAL ARRANGEMENT REPORT";
    const exportType = "xls";
    exportFromJSON({ data: exportData, fileName, exportType });
  };


  function printPage() {
    const containerElement = document.getElementsByClassName("page-content")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        color: #000 !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(() => {
      window.print();
      document.head.removeChild(style);
    }, 500);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Item Driver/Location Arrangement Report")}
            title={props.t("Reports")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Arrangement Report")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="timestamp"
                          label={props.t("Timestamp")}
                          value={selectedTimestamp}
                          type="select"
                          onChange={(e) => setSelectedTimestamp(e.target.value)}
                        >
                          <option value="">{props.t("Latest")}</option>
                          {allTimeStamps &&
                            allTimeStamps.map((e) => (
                              <option key={e._id} value={e.mark_time}>
                                {moment(e.mark_time).format("DD/MM/YYYY HH:mm")}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <Label>{props.t("Vehicle/Driver")}</Label>
                        <ReactSelect
                          name="location"
                          options={allVehicles}
                          isClearable={true}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={selectedVehicle}
                          onChange={setSelectedVehicle}
                          placeholder={props.t("Select Vehicle/Driver")}
                        />
                      </Col>
                      {/* <Col lg={6} md={6}>
                        <div className="text-center mt-4">
                          <Link
                            to="#"
                            onClick={() => {setConfirmClose(true)}}
                            className="btn btn-success waves-effect waves-light"
                          >
                            <i className="fa fa-print"></i> Print Report
                          </Link>
                        </div>
                      </Col> */}

                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>


          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="Arrangement_Report">
                    <Row>
                      <Col lg={2} md={2} sm={2}>

                        <div className="d-print-none" >
                          <Link
                            to="#"
                            onClick={() => {
                              printDiv('Arrangement_Report');
                            }}
                            className="btn btn-sm btn-success waves-effect waves-light"
                          >
                            <i className="fa fa-print"></i> Print Report
                          </Link>
                        </div>
                      </Col>
                      <Col md={8} className="d-print-none">
                      <h3 className="text-center">Driver/Location Arrangement Report </h3>
                      </Col>
                     <Col lg={8} md={8} sm={8} className="d-none d-print-block">
                     <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        marginBottom: '1rem',
                      }}
                    >
                      {/* Title - Left */}
                      <div style={{ width: '33.33%', textAlign: 'left' }}>
                        <h5 style={{ margin: 0 }}>Driver/Location Arrangement Report</h5>
                      </div>

                      {/* Driver - Center */}
                      <div style={{ width: '33.33%', textAlign: 'center' }}>
                        {selectedVehicle?.name && <h5 style={{ margin: 0 }}>{selectedVehicle.name ?? ''}</h5>}
                      </div>

                      {/* Date/Time - Right*/}
                      <div
                        style={{
                          width: '33.33%',
                          textAlign: 'right',
                        }}
                        className="d-none d-print-block"
                      >
                        <h6 style={{ margin: 0 }}>{moment().format('DD-MM-YYYY HH:mm')}</h6>
                      </div>
                    </div>

                    </Col>
                                        
                      <Col lg={2} sm={2} md={2} className="d-print-none">
                        <div className="float-right d-print-none">
                          <Button
                            type="submit"
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                              handleDownload2(arrData || []);
                            }}
                          >
                            <i className="mdi mdi-file-export"></i>
                            {props.t("Export CSV")}
                          </Button>
                        </div>

                      </Col>

                    </Row>
                    <hr />
                    {arrData &&
                      arrData?.map((section) => {
                        return (
                          <>
                            {/* <div className="d-print-none">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    printDiv(section.category);
                                  }}
                                  className="btn btn-sm btn-success mr-2"
                                >
                                  <i className="fa fa-print"></i> Print Category
                                </Link>
                              </div> */}
                            {/* <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => {
                                    handleDownload2(section);
                                  }}
                                >
                                  <i className="mdi mdi-file-export"></i>
                                  {props.t("Export CSV")}
                                </Button>
                              </div> */}
                            <div id={section.location}>
                              <CardTitle className="for-print-heading">
                                {section.location}
                              </CardTitle>

                              <ToolkitProvider
                                bootstrap4
                                keyField="_id"
                                data={
                                  section.items && section.items
                                }
                                columns={getColumns(section.items)}
                                noDataIndication={props.t(
                                  "No data to display."
                                )}
                                search
                                exportCSV
                              >
                                {(props) => (
                                  <BootstrapTable
                                    striped
                                    hover
                                    condensed
                                    {...props.baseProps}
                                  />
                                )}
                              </ToolkitProvider>
                              <hr />
                            </div>
                          </>
                        );
                      })}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
           {/* ---Close Reamarks Modal Start--- */}
                  {confirmClose && (
                    <SweetAlert
                      title={props.t("Are you sure?")}
                      warning
                      showCancel
                      cancelBtnText={props.t("No")}
                      confirmBtnText={props.t("Yes")}
                      confirmBtnBsStyle="success"
                      cancelBtnBsStyle="danger"
                      onConfirm={() => {
                        setConfirmClose(false);
                        printReport();
                      }}
                      onCancel={() => {
                        setConfirmClose(false);
                      }}
                    >
                      {props.t(
                        "Once you print the report, the timestamp will be saved and cannot be changed."
                      )}
                    </SweetAlert>
                  )}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemLocDriverArrangementReport))
);
